<template>
    <div id="sms-chat" class="d-flex flex-column">
        <InputSearchConversation
            :searchCountResult="CountsearchResult"
            :elemHighlighted="elemHighlighted"
            :currentSection="currentSection"
            :arrowBtnActivated="arrowBtnActivated"
            :resetSearch="resetSearch"
            :pageName="pageName"
            :showContactInfoSection="showContactInfoSection"
            v-on:searchChange="txtSearchChange($event, {})"
            v-on:searchClear="deleteHighlightText($event, {})"
            v-on:nextResultClick="nextResultClick($event, {})"
            v-on:previousResultClick="previousResultClick($event, {})"
        ></InputSearchConversation>
        <div class="loading-active-conversatio-box content d-flex justify-content-center" v-if="loading">
            <span class="spinner spinner-border text-primary align-self-center"></span>
        </div>
        <div class="content d-flex flex-column pt-0 justify-content-end" v-else>
            <output
                id="load-more-conversations"
                class="align-self-center fs-12 text-black"
                v-if="loadMoreLoading">
                {{ $t('loading-history') }}
            </output>
            <div
                id="conversationsSection"
                class="conversations-section mt-0"
                :class="{
                    'wihout-dashboard': !showDashboard,
                    'wihout-dashboard': !showDashboard
                }"
                v-scroll="infiniteScrollOpposite"
            >
                <div class="conversation d-flex flex-column-reverse" v-for="conversation in conversations" :key="conversation.id">
                    <div v-if="conversation.messages && conversation.attributes['ended-at']" class="conversation-end">
                        <p>
                            {{ $t('conversation-terminated') }} {{ formatDate(moment(conversation.attributes['updated-at'])).toLowerCase() }}
                            <span v-if="users && conversation.relationships.users.data[0] && users[conversation.relationships.users.data[0].id]">
                                {{ $i18n.t('by') }}
                                {{ users[conversation.relationships.users.data[0].id].attributes['first-name'] }}
                                {{ users[conversation.relationships.users.data[0].id].attributes['last-name'] }}
                            </span>
                        </p>
                    </div>
                    <div v-for="(message, index) in conversation.messages"
                        :key="message.id"
                        class="message"
                        :class="{
                            'user-message text-right': message.direction === 'mobile_terminated',
                            'contact-message text-left': message.direction === 'mobile_originated'
                        }"
                    >
                        <div
                            class="mb-3"
                            :class="{
                                'right-message': message.direction === 'mobile_terminated',
                                'left-message': message.direction === 'mobile_originated'
                            }"
                        >
                            <div>
                                <div class="d-flex justify-content-end" v-if="message.content">
                                    <p class="text-message" :class="{
                                            'animated': index == conversation.messages.length - 1,
                                            'mass-message': message['is-mass'],
                                            'flash-message': message['is-flash'],
                                            'auto-response-message': message['is-auto-response'],
                                        }">
                                        {{ message.content }}
                                    </p>
                                </div>
                                <div class="media-content" v-if="message.category == 'mms' && message.media?.length > 0">
                                    <div v-for="media in message.media" :key="media.id">
                                        <div class="d-flex justify-content-start my-2 align-items-center" v-if="media.format.includes('image')">
                                            <a class="d-flex justify-content-start align-items-center" :href="media.url" target="_blank">
                                                <img class="mw-100" :src="media.url" alt="">
                                            </a>
                                        </div>
                                        <div class="d-flex justify-content-start my-2 align-items-center" v-if="media.format.includes('video')">
                                            <video class="mw-100" controls>
                                                <source :src="media.url" :type="media.format" />
                                            </video>
                                        </div>
                                    </div>
                                </div>
                                <small class="message-date">
                                    <span v-if="message['is-mass']"> {{ $t('massive-send') }}: </span>
                                    <span v-if="message['is-flash']"> {{ $t('flash-message') }}: </span>
                                    <span v-if="message['is-auto-response']"> {{ $t('auto-response') }}: </span>
                                    {{ formatDate(moment(message['created-at'])) }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <!-- div class="conversation-end d-flex align-items-center">
                        <div class="line"></div>
                        <p>
                            {{ $t('conv-ended-automatically') }} {{ fromUtc(moment(conversation.attributes['updated-at'])).date.toLowerCase()  }}
                        </p>
                        <div class="line"></div>
                    </div -->
                </div>
            </div>
            <div class="dashboard w-100 mx-0" v-if="showDashboard">
                <div>
                    <form>
                        <select-dropdown
                            :options="options"
                            :selected="selectedTemplate"
                            v-on:selectTemplate="chooseTemplate($event)"
                            :showLabel="false"
                            :type="'template'"
                            :isDisabled="isFormDisabled">
                        </select-dropdown>
                        <div class="response-section mt-2" :class="{'text-focused': isSmsTextFocused, 'disabled': isFormDisabled}">
                            <div class="message-content">
                                <textarea
                                    class="text-section form-control mb-2 select-template"
                                    name="message"
                                    id="message"
                                    ref="messageText"
                                    v-on:focusin="isSmsTextFocused = true"
                                    v-on:focusout="isSmsTextFocused = false"
                                    :placeholder="isFormDisabled ? chatPlaceholder : $t('write-your-response')"
                                    v-model="smsText"
                                    :disabled="isFormDisabled"
                                    :class="{'disabled-textarea': isFormDisabled}"
                                    @keyup="disabled = (smsText === '')"
                                    @input="autoTextareaResize"
                                >
                                </textarea>
                                <div class="media-preview d-flex" v-if="previewMedia.length > 0">
                                    <div class="gallery-wrapper">
                                        <div
                                            class="gallery"
                                            ref="gallery"
                                            @mousedown="startDrag"
                                            @mouseleave="isDragging = false"
                                            @mouseup="isDragging = false"
                                            @mousemove="onDrag"
                                        >
                                            <div v-for="(media, index) in previewMedia" :key="index">
                                                <div class="remove" @click="removeMedia(index)">
                                                    <div class="icon">
                                                       <font-awesome-icon :icon="['fas', 'circle-xmark']" />
                                                    </div>
                                                </div>
                                                <img
                                                    v-if="media.type === 'image'"
                                                    :src="media.url"
                                                    :alt="`Image ${index + 1}`"
                                                    class="gallery-element"
                                                    draggable="false"
                                                />
                                                <video class="gallery-element" draggable="false" v-if="media.type === 'video'" controls>
                                                    <source :src="media.url" type="video/mp4" />
                                                </video>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="media-icons d-flex mt-2" v-if="isMmsAllowed">
                                <div class="image-icon">
                                    <label for="image-file" class="mb-0">
                                        <font-awesome-icon class="icon" :class="{'disabled': isImageMediaDisabled || isFormDisabled}" :icon="['fas', 'image' ]"/>
                                    </label>
                                    <input
                                        type="file"
                                        name="image-file"
                                        ref="image"
                                        id="image-file"
                                        accept="image/*"
                                        multiple
                                        :disabled="isImageMediaDisabled || isFormDisabled"
                                        hidden
                                        @change="onMediaInputChange($event, 'image')"
                                    />
                                </div>
                                <div class="video-icon">
                                    <label for="video-file" class="mb-0">
                                        <font-awesome-icon class="icon" :class="{'disabled': isVideoMediaDisabled || isFormDisabled}" :icon="['fas', 'video' ]" />
                                    </label>
                                    <input
                                        type="file"
                                        name="video-file"
                                        ref="video"
                                        id="video-file"
                                        :disabled="isVideoMediaDisabled || isFormDisabled"
                                        accept="video/mp4"
                                        @change="onMediaInputChange($event, 'video')"
                                        hidden
                                    />
                                </div>
                            </div>
                        </div>
                        <sms-counter :sms="smsText" v-on:limitExceeded="smsLimitExceeded = $event" v-if="!isFormDisabled"></sms-counter>
                    </form>
                </div>
                <div class="row mt-3">
                    <div class="col-6 text-left pl-3 pt-md-0 pt-2"
                        :key="contactActiveConversation.id"
                        v-if="contactActiveConversation && currentUserCanChatWithContact"
                        id="terminate-conversation"
                    >
                        <router-link :to="{ name: '' }" @click.native="terminateSingleContactConversation()"
                            v-if="this.numberToActivate === null"
                            class="text-left text-danger end-discussion-text">
                            {{ $t('end-the-conversation') }}
                        </router-link>
                    </div>
                    <div v-bind:class="[ (contactActiveConversation && currentUserCanChatWithContact) ? 'col-6' : 'col-12' ]" class="text-right">
                        <button
                            class="btn btn-primary btn-paper-plane style-btn style-btn"
                            @click="sendMessage()"
                            :disabled="isButtonDisabled"
                        >
                            <font-awesome-icon class="paper-plane" :icon="['fas', 'paper-plane']" v-if="!sendingSms"/>
                            <span class="spinner-border spinner-border" role="status" aria-hidden="true" v-if="sendingSms"></span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end my-2" v-else>
                <div class="mr-5" >
                    <span class="initials fs-10 pointer" v-popover.top="{ name: `active-user-${currentConversationUser.id}` }">
                        {{ userInitials }}
                    </span>
                    <img class="icone-message mb-4" src="@/core/assets/images/icon-message.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

// Components
import SelectDropdown from '../../../core/components/SelectDropdown.vue';
import SmsCounter     from './SmsCounter.vue';
import InputSearchConversation     from './InputSearchConversation.vue';

// Internal services js
import {
    mapState, mapActions, mapGetters
} from 'vuex';
import Format              from '@/helpers/Format.js';
import Alert               from '@/helpers/Alert.js';
import SearchSmsMixin      from '@/core/mixins/SearchSmsMixin';
import InfiniteScrollMixin from '@/core/mixins/InfiniteScrollMixin';

// External services js
import HttpStatus from 'http-status-codes';
import moment     from 'moment';

export default {
    components: {
        SelectDropdown, SmsCounter, InputSearchConversation
    },

    mixins: [SearchSmsMixin, InfiniteScrollMixin],

    props: {
        currentSection: {
            default: '',
            type:    String
        },
        pageName: {
            default: '',
            type:    String
        },
        resetSearch: {
            default: false,
            type:    Boolean
        },
        loadTerminatedConversations: {
            default: true,
            type:    Boolean
        },
        showContactInfoSection: {
            default: true,
            type:    Boolean
        },
        showDashboard: {
            default: true,
            type:    Boolean
        },
        loadConversationlessMessages: {
            default: false,
            type:    Boolean
        }
    },

    data () {
        const MAX_IMAGES = 10;
        const MAX_VIDEOS = 1;

        return {
            selectedTemplate: this.$i18n.t('choose-template'),
            smsMessage:       '',
            selectFilter:     this.$i18n.t('all'),
            smsLimitExceeded: false,
            isSmsTextFocused: false,
            smsFilter:        [
                'all',
                'last-7-days',
                'active-conversation'
            ],
            smsText:  '',
            disabled: true,
            options:  [],

            conversationsPage:            0,
            conversationsPageTotal:       0,
            currentConversationId:        null,
            currentConversationPage:      0,
            currentConversationPageTotal: 0,

            messagesPageSize:    20,
            messagesPageTimeout: null,

            // Loadings
            loading:         false,
            sendingSms:      false,
            loadMoreLoading: false,
            messagesLoaded:  0,

            // Media section
            isDragging:   false,
            currentType:  null,
            startX:       0,
            scrollLeft:   0,
            previewMedia: [],
            MAX_IMAGES,
            MAX_VIDEOS
        };
    },

    watch: {
        smsText (newValue) {
            if (!newValue) {
                this.selectedTemplate = this.$i18n.t('choose-template');
                this.disabled         = true;
            }
        },

        currentContactStatuUpdated () {
            // If we are in ContactHistory we reload the conversations
            if (this.loadTerminatedConversations) {
                this.conversationsPage = 0;
                this.conversationsPageTotal = 0;
                this.currentConversationId = null;
                this.currentConversationPage = 0;
                this.currentConversationPageTotal = 0;
                this.messagesLoaded =  0;

                this.getConversationsDetails();
            }
        }
    },

    computed: {
        keywords () {
            return this.words.split(' ');
        },

        /**
         * Check if the send form is disabled
         *
         * @retun   {boolean}
         */
        isFormDisabled () {
            return (!this.isSubscribed ||
                !this.numberGetter ||
                this.numberToActivate ||
                this.contact.attributes['deleted-at'] !== null ||
                (this.contactActiveConversation && !this.currentUserCanChatWithContact)
            );
        },

        /**
         * Get the Chat placeholder
         *
         * @return {string}
         */
        chatPlaceholder () {
            if (!this.isSubscribed) {
                return this.$i18n.t('stop-request-received');
            } else if (this.numberToActivate) {
                return this.$i18n.t('phone-not-activated-yet');
            } else if (!this.numberGetter) {
                return this.$i18n.t('no-phone-number-configured');
            } else if (this.contact.attributes['deleted-at'] !== null) {
                return this.$i18n.t('archived-contact');
            }

            return this.$i18n.t('conversation-assigned-to-user', {
                name: this.currentConversationUser ?
                    `${this.currentConversationUser.attributes['first-name']} ${this.currentConversationUser.attributes['last-name']}` :
                    ''
            });
        },

        /**
         * Check if the send button is disabled
         *
         * @retun   {boolean}
         */
        isButtonDisabled () {
            return (
                !this.isSubscribed ||
                !this.numberGetter ||
                this.disabled ||
                this.sendingSms ||
                this.smsLimitExceeded ||
                (this.contactActiveConversation && !this.currentUserCanChatWithContact)
            ) && this.previewMedia.length === 0;
        },

        /**
         * Check if the image input file is disabled
         */
        isImageMediaDisabled () {
            return this.currentType === 'video' ||  (this.currentType === 'image' && this.previewMedia.length === this.MAX_IMAGES);
        },

        /**
         * Check if the video input file is disabled
         */
        isVideoMediaDisabled () {
            return this.currentType === 'image' || (this.currentType === 'video' && this.previewMedia.length === this.MAX_VIDEOS);
        },

        /**
         * Check if the current provider allows MMS send
         */
        isMmsAllowed () {
            return this.connectedProvider?.attributes['mmsAllowed'];
        },

        /**
         * State of SMS conversation
         *
         */
        ...mapState('core/conversations', {
            contactHasConversations:    'contactHasConversations',
            contactActiveConversation:  'contactActiveConversation',
            contactConversations:       'contactConversations',
            currentContactStatuUpdated: 'currentContactStatuUpdated'
        }),

        /**
         * State for current active conversation with the current contact
         * Single contact
         * Conversations
         */
        ...mapState('core/contacts', { contact: 'single' }),

        /**
         * State of tenant
         *
         * selectedTenant    State of the tenant the user has selected
         */
        ...mapState('core/tenants', { selectedTenant: 'selectedTenant' }),

        /**
         * State of templates
         * templates    State of all templates
         */
        ...mapState('core/templates', [
            'templates'
        ]),

        /**
         * State of SMS messages
         * messages    State of all SMS messages
         */
        ...mapState('core/sms-messages', ['messages']),

        /**
         * Getters for conversations
         */
        ...mapGetters('core/conversations', [
            'isSubscribed',
            'currentUserCanChatWithContact',
            'currentConversationUser'
        ]),

        // Getter for the selected phone number
        ...mapGetters('core/number', { numberGetter: 'smsPhoneNumber', numberToActivate: 'numberToActivate' }),

        /**
         * Providers getters
         */
        ...mapGetters('core/providers', ['connectedProvider']),

        /**
         * Get the current conversation active user initials
         */
        userInitials () {
            if (this.currentConversationUser) {
                return this.currentConversationUser.attributes['first-name'].charAt(0).toUpperCase() + this.currentConversationUser.attributes['last-name'].charAt(0).toUpperCase();
            }

            return null;
        },

        /**
         * Get the conversations
         */
        conversations () {
            // Get conversations from store
            const conversations = this.contactConversations.conversations;

            // Check if conversationless messages are loaded
            if (!this.messages) {
                return Object.values(conversations).sort((a, b) => new Date(b.attributes['created-at']) - new Date(a.attributes['created-at']));
            }

            // Map conversationless messages as conversations
            const conversationlessMessages = Object.values(this.messages);
            const conversationlessConversations = {};

            conversationlessMessages.forEach((message) => {
                conversationlessConversations[`conversationless-${message.id}`] = {
                    id:         `conversationless-${message.id}`,
                    attributes: {
                        'created-at': message['created-at'],
                        'updated-at': message['updated-at'],
                        'ended-at':   null
                    },
                    messages: [message]
                };
            });

            const arrayConversations = Object.values({ ...conversationlessConversations, ...conversations });
            return arrayConversations.sort((a, b) => new Date(b.attributes['created-at']) - new Date(a.attributes['created-at']));
        },

        /**
         * Get the users
         */
        users () {
            return { ...this.contactConversations.users, ...this.messagesUsers };
        }
    },

    mounted () {
        this.autoTextareaResize();
        this.getConversationsDetails();

        // Listen to the websocket event.
        if (this.loadTerminatedConversations) {
            this.update({ tenantId: this.selectedTenant.id });
        }

        this.getTemplate().then(() => {
            this.options.push({
                'id':      null,
                'name':    this.$i18n.t('choose-template'),
                'content': ''
            });
            for (const templateId in this.templates) {
                this.options.push({
                    'id':      templateId,
                    'name':    this.templates[templateId].attributes.name,
                    'content': this.templates[templateId].attributes.content
                });
            }
        });
    },

    methods: {
        /**
         * Methods for SMS API requests
         */
        ...mapActions('core/sms-messages', {
            newSms:             'create',
            newMms:             'createMms',
            getMessages:        'index',
            resetMessagesState: 'resetMessagesState'
        }),

        /**
         * Load templates
         */
        ...mapActions('core/templates', { getTemplate: 'index' }),

        /**
         * SetActiveContact      set the active contact
         * terminateConversation ends a conversation
         *
         */
        ...mapActions('core/conversations', [
            'getContactConversations',
            'getConversationMessages',
            'setActiveContact',
            'terminateConversation',
            'resetSingleConversation',
            'stopListeningToWebsocket',
            'update'
        ]),

        /**
         * Define moment to use it in template
         */
        moment,

        /**
         * Auto resize the text box
         */
        autoTextareaResize () {
            const textarea = this.$refs.messageText;

            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        },

        /**
         * Preview loaded images or videos
         *
         * @param event
         * @param type   the media type
         */
        onMediaInputChange (event, type) {
            if (this.currentType !== null && this.currentType !== type) {
                Alert.fail(this.$i18n.t('no-media-mix'));
                return;
            }

            const files = event.target.files;

            // eslint-disable-next-line no-magic-numbers
            const MAX_FILES = type === 'image' ? this.MAX_IMAGES : this.MAX_VIDEOS;
            if (this.previewMedia.length === MAX_FILES) {
                this.resetMediaInput(type);
                Alert.fail(this.$i18n.t('max-files', { max: MAX_FILES }));
                return;
            }

            // eslint-disable-next-line no-magic-numbers
            const ONE_MB = 1024 * 1024;

            let validFiles  = [];
            let totalFiles = 0;

            for (const file of files) {
                totalFiles = this.previewMedia.length + validFiles.length;
                if (totalFiles >= MAX_FILES) {
                    Alert.fail(this.$i18n.t('max-files', { max: MAX_FILES }));
                    break;
                }

                if (file.size > ONE_MB) {
                    Alert.fail(this.$i18n.t('large-file', { name: file.name, size: 1 }));
                    continue;
                }

                validFiles.push(file);
            }

            validFiles = validFiles
                .filter(file => file.type.startsWith(`${type}/`))
                .map(file => ({
                    type,
                    url:  URL.createObjectURL(file),
                    name: file.name,
                    file
                }));

            this.previewMedia = this.previewMedia.concat(validFiles);

            this.resetMediaInput(type);
            this.currentType = this.previewMedia.length > 0 ? type : null;
        },

        /**
         * Remove a media from the preview list
         *
         * @param index
         */
        removeMedia (index) {
            this.previewMedia.splice(index, 1);
            if (this.previewMedia.length === 0) {
                this.currentType = null;
            }
        },

        /**
         * Reset the file input
         *
         * @param type  image or video
         */
        resetMediaInput (type) {
            this.$refs[type].value = '';
        },

        /**
         * Fetch conversation details
         */
        getConversationsDetails () {
            this.loading = true;

            // Init the conversation board and then load new data
            this.resetSingleConversation();
            this.setActiveContact({ contactId: this.contact.id });

            // Load first conversation
            this.loadNextConversation(false);

            // Load conversationless messages
            if (this.loadConversationlessMessages) {
                this.getMessages({
                    filters: {
                        'conversationless': 1,
                        'to':               this.contact.attributes['phone-number'].replace('+', '')
                    },
                    sort:    'created-at',
                    include: 'user'
                });
            } else {
                this.resetMessagesState();
            }
        },

        /**
         * Load next conversation
         */
        async loadNextConversation (append) {
            let filters  =  {};
            if (!this.loadTerminatedConversations) {
                filters = { 'is-active': 1 };
            }

            // Load next conversation
            this.conversationsPage += 1;

            this.getContactConversations({
                id:   this.contact.id,
                append,
                page: {
                    size:   1,
                    number: this.conversationsPage
                },
                filters
            }).then(async (response) => {
                this.conversationsPageTotal = response.meta.page['last-page'];

                // Load the messages for the first conversation
                if (response.data.conversations === undefined) {
                    this.loading = false;
                    return;
                }

                const conversations = Object.values(response.data.conversations);
                if (conversations.length === 0) {
                    this.loading = false;
                    return;
                }

                // Load conversations until we fill the page
                await this.loadConversationMessages(conversations[0]);

                // Stop if we filled the page
                if (this.messagesLoaded >= this.messagesPageSize) {
                    this.loading = false;
                    this.enableInfiniteScroll();
                    return;
                }

                // If we never reached the page size, loading is done, but do not enable infinite scroll
                const timeout = 500;
                this.messagesPageTimeout = setTimeout(() => {
                    this.loading = false;
                }, timeout);
            });
        },

        /**
         * Fill page with conversations
         */
        async loadConversationMessages (conversation) {
            this.currentConversationId   = conversation.id;
            this.currentConversationPage = 1;

            await this.getConversationMessages({
                conversationId: conversation.id,
                append:         false,
                page:           {
                    size:   this.messagesPageSize,
                    number: 1
                }
            })
                .then((response) => {
                    this.messagesLoaded += Object.values(response.data.messages).length;
                    this.currentConversationPageTotal = response.meta.page['last-page'];

                    // If we still have space in the page, load next conversation
                    if (this.messagesLoaded < this.messagesPageSize && this.conversationsPage < this.conversationsPageTotal) {
                        this.loadNextConversation(true);
                    }
                });
        },

        /**
         * Update selected option
         *
         * @return    void
         */
        chooseTemplate (option) {
            if (option.id === null) {
                this.selectedTemplate = option.name;
                this.disabled = option.id === null;
            } else if (this.smsText === '') {
                this.selectedTemplate = option.name;
                this.smsText = option.content;
                this.disabled = option.id === null;
            } else {
                Alert.confirmation(this.$i18n.t('this-will-replace-message'), this.$i18n.t('replace'))
                    .then((response) => {
                        if (response.isConfirmed) {
                            this.selectedTemplate = option.name;
                            this.smsText = option.content;
                        }
                    });
            }
        },

        /**
         * Send SMS/MMS to contact
         */
        sendMessage () {
            if (this.isButtonDisabled) {
                return;
            }

            this.sendingSms = true;
            let action = 'newSms';
            const attributes = {
                phoneNumber: this.contact.attributes['phone-number'],
                content:     this.smsText
            };

            if (this.previewMedia.length > 0) {
                attributes.media = this.previewMedia;
                action = 'newMms';
            }

            this[action](attributes)
                .then(async () => {
                    this.smsText = '';
                    this.previewMedia = [];
                    this.currentType = null;
                    Alert.success(this.$i18n.t('message-sent'));
                    this.$emit('conversationUpdated');
                })
                .catch((errors) => {
                    if (errors.response && errors.response.status === HttpStatus.UNPROCESSABLE_ENTITY) {
                        Alert.fail((errors.response.data.errors[0].detail));
                    }
                })
                .finally(() => {
                    this.sendingSms = false;
                    const container = document.querySelector('#conversationsSection');
                    container.scrollTop = container.scrollTo(0, container.scrollHeight);
                    this.disabled = true;
                });
        },

        /**
         * Terminate conversation
         */
        terminateSingleContactConversation () {
            Alert.confirmation(this.$i18n.t('end-the-conversation'), this.$i18n.t('terminate'))
                .then((result) => {
                    if (result.isConfirmed) {
                        this.terminateConversation({ id: this.contactActiveConversation.id })
                            .then(() => {
                                this.$emit('conversationTerminated');
                            });
                    }
                });
        },

        /**
         * Infinite scroll end reached callback from infinite scroll mixin.
         */
        infiniteScrollEndReached () {
            // Disable the infinite scroll when the user reaches the end
            this.disableInfiniteScroll();

            // Load next conversation messages page
            const loadMoreTimer = 500;
            if (this.currentConversationPage < this.currentConversationPageTotal) {
                this.loadMoreLoading = true;
                this.currentConversationPage++;

                this.getConversationMessages({
                    conversationId: this.currentConversationId,
                    append:         true,
                    page:           {
                        size:   this.messagesPageSize,
                        number: this.currentConversationPage
                    }
                }).then(() => {
                    setTimeout(() => {
                        this.loadMoreLoading = false;
                        this.enableInfiniteScroll();
                    }, loadMoreTimer);
                });
            } else if (this.conversationsPage < this.conversationsPageTotal) {
                // Load next conversation
                this.loadMoreLoading = true;
                this.currentConversationPage = 1;

                this.loadNextConversation(true).then(() => {
                    setTimeout(() => {
                        this.loadMoreLoading = false;
                        this.enableInfiniteScroll();
                    }, loadMoreTimer);
                });
            }
        },

        /**
         * Define formatDate method to be used in template
         */
        formatDate: Format.formatDate,

        /**
         * Helper method to format date to use in template
         */
        fromUtc: Format.fromUtc,

        /**
         * Start dragging movement for the preview section (images or videos)
         *
         * @param event
         */
        startDrag (event) {
            this.isDragging = true;

            const gallery = this.$refs.gallery;

            this.startX = event.pageX - gallery.offsetLeft;
            this.scrollLeft = gallery.scrollLeft;
        },

        /**
         * During dragging movement for the preview section (images or videos)
         *
         * @param event
         */
        onDrag (event) {
            if (!this.isDragging) {
                return;
            }

            event.preventDefault();

            const step = 1.5;
            const gallery = this.$refs.gallery;
            const xPosition = event.pageX - gallery.offsetLeft;
            const movement = (xPosition - this.startX) * step;

            gallery.scrollLeft = this.scrollLeft - movement;
        }
    },

    destroyed () {
        this.resetSingleConversation();
        if (this.loadTerminatedConversations) {
            this.stopListeningToWebsocket(this.selectedTenant.id);
        }
    }
};
</script>
<style scoped lang="scss">
    .gallery-wrapper {
        width: 100%;
        overflow: hidden;
        min-width: 0;
    }

    .gallery {
        width: 100%;
        display: flex;
        gap: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        cursor: grab;
        user-select: none;
        padding-bottom: 10px;
        box-sizing: border-box;

        .remove {
            color: red;
            position: relative;

            .icon {
                position: absolute;
                right: 0;
                cursor: pointer;

                svg {
                    font-size: 17px;
                    padding: 5px;
                    color: #edeff1;
                    filter: drop-shadow(0 0 5px rgb(99, 98, 98));
                }
            }
        }
    }

    .gallery:active {
        cursor: grabbing;
    }

    .gallery::-webkit-scrollbar {
        height: 8px;
    }

    .gallery::-webkit-scrollbar-thumb {
        background: #cccccc;
        border-radius: 4px;
    }

    .gallery-element {
        max-width: 300px;
        height: 150px;
        object-fit: cover;
        flex-shrink: 0;
        pointer-events: none;
    }
</style>
